/**
 * /star — LP de venda da Star Cursos (cópia fiel e melhorada da página Wix).
 * Copy validada em src/lib/star/config.ts; planos com checkout Eduzz embutido.
 */
import { useBlackfeo } from "@/hooks/use-blackfeo";
import { BlackfeoPopup, BlackfeoTopBar } from "@/components/blackfeo/BlackfeoPontos";
import { createFileRoute } from "@tanstack/react-router";
import tabletCursos from "@/assets/revista-star/tablet-cursos.webp.asset.json";

import {
  StarCarreira,
  StarComoFunciona,
  StarDepoimentos,
  StarDuvidas,
  StarFaq,
  StarGarantias,
  StarHero,
  StarNomes,
  StarPlanos,
  StarSobre,
  StarStats,
  StarStickyCta,
  StarVideo,
} from "@/components/star/blocks";

const TITLE = "Star Cursos · assinatura de cursos de fisioterapia musculoesquelética";
const DESCRIPTION =
  "A maior biblioteca online de cursos na área da fisioterapia musculoesquelética: +100 cursos com certificação, +50 professores e +350 horas de conteúdo. Assinatura anual a partir de R$307.";

export const Route = createFileRoute("/star")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:image", content: `https://fisioemortopedia.com.br${tabletCursos.url}` },
      { name: "twitter:image", content: `https://fisioemortopedia.com.br${tabletCursos.url}` },
      { property: "og:url", content: "https://fisioemortopedia.com.br/star" },
    ],
    links: [{ rel: "canonical", href: "https://fisioemortopedia.com.br/star" }, { rel: "preload", as: "image", href: tabletCursos.url, fetchPriority: "high" }],
  }),
  component: StarPage,
});

function StarPage() {
  const blackfeo = useBlackfeo();
  return (
    <main className="min-h-screen bg-white antialiased pb-20 lg:pb-0">
      {blackfeo && <BlackfeoTopBar ponto="lp-star" produto={{ off: "68% OFF", href: "#planos" }} />}
      {blackfeo && <BlackfeoPopup ponto="lp-star" destino={{ off: "68% OFF", href: "#planos" }} />}
      <StarHero />
      <StarStats />
      <StarSobre />
      <StarComoFunciona />
      <StarVideo />
      <StarCarreira />
      <StarNomes />
      {blackfeo && <BlackfeoTopBar ponto="lp-star-oferta" fixa={false} produto={{ off: "68% OFF", href: "#planos" }} />}
      <StarPlanos />
      <StarGarantias />
      <StarDepoimentos />
      <StarFaq />
      <StarDuvidas />
      <StarStickyCta />
    </main>
  );
}
